<template>
	<div id="app" style="background-color: #F5F5F5;color: #000;font-weight: 900;height: 100vh;">
		<canvas id="cvs1" style="display: none;"></canvas>
		<div style="padding: 10px;border-bottom: 1px solid #000;font-size: 28px;">
			<span v-if="sta==0">Fitting前数据测量</span><span v-if="sta==0" style="font-size: 18px;margin-left:20px;">调整数据前，踩踏一段，然后保存为Fitting前参数</span>
			<span v-if="sta==1">动态Fitting中</span><span v-if="sta==1" style="font-size: 18px;margin-left:20px;">调整完毕后，保存参数并完成动态评估</span>
			<span v-if="call!=''" style="color: #00B83F;font-size: 18px;">
				{{call}}
			</span>
			<span v-else style="color: #00B83F;font-size: 18px;">
				为保障测量精确，请穿短袖短裤骑行服和锁鞋。
			</span>
			<span v-if="fps<24&&fps!=0" style="color: red;font-size: 18px;">
				FPS过低，请刷新重新载入或检查设备性能
			</span>
			
			<span style="float: right;">
				FPS:<span style="color: #00B83F;">{{fps}}</span>
			</span>


		</div>
		<div style="display: flex;margin-left: 20px;padding-top:10px;">

			<div style="flex: 2;width: 200px;text-align: center;">
				<div style="display: flex;justify-content: center;font-size: 16px;">
					<div>
						<div style="text-align: center">
							髋关节稳定性
						</div>
						<div style="width: 166px;height: 166px;background: #000;margin-top: 10px;">
							<canvas id="cvs6"></canvas>
						</div>
					</div>

				</div>
				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div>
						<div style="text-align: center">
							踝关节稳定性
						</div>
						<div style="width: 166px;height: 166px;background: #000;margin-top: 10px;">
							<canvas id="cvs2"></canvas>
						</div>
					</div>

				</div>
				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div>
						<div style="text-align: center">
							膝关节踏稳定性
						</div>
						<div style="width: 166px;height: 166px;background: #000;margin-top: 10px;">
							<canvas id="cvs3"></canvas>
						</div>
					</div>
				</div>
				<div>
					<button @click="wd_clean" class="btn btn-primary" style="margin-top: 20px;">稳定性重置</button>
				</div>
			</div>
			<div style="flex: 2;padding: 10px 20px;font-size: 16px;max-width: 400px;">
				<div style="padding: 5px;" >
					<div style="display: flex">
						<div style="width: 160px;">踏频</div>
						<div style="margin: 0 20px;color: #00B83F;width: 60px;">{{crc_count}}</div>					
						
					</div>
				</div>
				<div v-for="(item, index) in dat" style="padding: 5px;" :key="index">
					<div style="display: flex">
						<div style="width: 160px;">{{item.name}}</div>
						<div v-if="item.color=='green'" style="margin: 0 20px;color: #00B83F;width: 60px;">{{item.val}}</div>
						<div v-if="item.color=='yellow'" style="margin: 0 20px;color: #ece864;width: 60px;">{{item.val}}</div>
						<div v-if="item.color=='red'" style="margin: 0 20px;color: #b41a3f;width: 60px;">{{item.val}}</div>
					</div>
				</div>
				<!-- <div style="padding: 5px;" >
					<div style="display: flex">
						<div style="width: 160px;">FPS</div>
						<div v-if="fps>=23||fps==0" style="margin: 0 20px;color: #00B83F;width: 60px;">{{fps}}</div>						
						<div v-else style="margin: 0 20px;color: #b41a3f;width: 60px;">{{fps}}</div>
					</div>
				</div> -->
				
			</div>

			<div style="flex: 5;display: flex;justify-content: center;">
				<div>

					<div style="width: 500px; height: 500px; background: #000; display: flex; justify-content: center; align-items: center; position: relative;">
						<canvas id="cvs5" style="position: absolute;z-index: 999;"></canvas>
						<video crossOrigin="anonymous" id="vid" :autoplay="false" muted loop @play="go_init" src="https://bikecdn.typhcl.cn/fitting/test.mp4" :style="'position: absolute; max-width: 100%; max-height: 100%;'+(vst?'z-index:999;':'z-index:-999;')" :controls="false"></video>
					</div>

					<div style="display: flex;justify-content: space-between;">

						<div style="background: #000;width: 400px;height: 200px;margin-top: 10px;" id="qxt">

						</div>
						<div style="width: 100px;height: 200px;padding-left: 20px;">
							<button :class="'btn '+ (map_name == 'hip' ? 'btn-success' : 'btn-primary')" @click="set_map_name('hip')" style="margin-top: 5px;">髋关节</button>
							<button :class="'btn '+ (map_name == 'knee' ? 'btn-success' : 'btn-primary')" @click="set_map_name('knee')" style="margin-top: 5px;">膝关节</button>
							<button :class="'btn '+ (map_name == 'ankle' ? 'btn-success' : 'btn-primary')" @click="set_map_name('ankle')" style="margin-top: 5px;">踝关节</button>
							<button :class="'btn '+ (map_name == 'elbow' ? 'btn-success' : 'btn-primary')" @click="set_map_name('elbow')" style="margin-top: 5px;">肘关节</button>
							<button :class="'btn '+ (map_name == 'shoulder' ? 'btn-success' : 'btn-primary')" @click="set_map_name('shoulder')" style="margin-top: 5px;">肩关节</button>
							<button :class="'btn '+ (map_name == 'wrist' ? 'btn-success' : 'btn-primary')" @click="set_map_name('wrist')" style="margin-top: 5px;">腕关节</button>

						</div>
					</div>

					<div v-if="ready">
						<button v-if="zt" @click="pause()" class="btn btn-primary" style="margin-top: 10px;margin-right: 10px;">暂停</button>
						<button v-else @click="pause()" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;">继续</button>



					<!-- 	<button v-if="ddd" @click="ddd=!ddd" class="btn btn-primary" style="margin-top: 10px;margin-right: 10px;">关闭3D</button>
							<button v-else @click="ddd=!ddd" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;">开启3D</button> -->
						<!-- <button v-if="jt" @click="jt=!jt" class="btn btn-primary" style="margin-top: 10px;margin-right: 10px;">关闭截图</button>
						<button v-else @click="jt=!jt" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;">开启截图</button> -->
						<button v-if="!vst" @click="vst=!vst" class="btn btn-primary " style="margin-top: 10px;margin-right: 10px;">实景</button>
						<button v-else @click="vst=!vst" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;">模拟</button>
						<button class="btn btn-success" @click="next_cam" style="margin-top: 10px;margin-right: 10px;" v-if="call==''">切换摄像头</button>
						<button class="btn btn-success" @click="clear" style="margin-top: 10px;margin-right: 10px;">清空</button>

						<button @click="save_fq" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;" v-if="sta==0">保存为Fitting前参数</button>
						<button @click="save_af" class="btn btn-success" style="margin-top: 10px;margin-right: 10px;" v-if="sta==1">保存参数并完成动态评估</button>
					</div>
					<div v-else style="padding: 20px;">
						加载分析模块中，超过一分钟没载入成功请刷新页面
					</div>
				</div>

			</div>
			<div style="flex: 2;padding: 00px 20px;font-size: 16px;max-width: 400px;">


				<div>
					<div style="background: #000;width: 220px;height: 220px;border-radius: 50%;padding:10px;" id="ybt">

					</div>
					<div style="width: 100%;text-align: center;padding: 5px;font-size: 14px;">
						{{fs[map_name]}}平均最大伸展<br>
						{{fs[map_name]}}当前极限伸展:
						<span v-if="show_max_c=='green'" style="color: #00B83F;">{{show_max}}</span>
						<span v-if="show_max_c=='yellow'" style="color: #ece864;">{{show_max}}</span>
						<span v-if="show_max_c=='red'" style="color: #b41a3f;">{{show_max}}</span><br>
						参考范围：{{dat_line[map_name].u_max}}-{{dat_line[map_name].u_min}}°
					</div>
				</div>

				<div>
					<div style="background: #000;width: 220px;height: 220px;border-radius: 50%;padding:10px;margin-top: 10px;" id="ybt2">

					</div>
					<div style="width: 100%;text-align: center;padding: 5px;font-size: 14px;">
						{{fs[map_name]}}平均最小收缩<br>
						{{fs[map_name]}}当前极限收缩:
						<span v-if="show_min_c=='green'" style="color: #00B83F;">{{show_min}}</span>
						<span v-if="show_min_c=='yellow'" style="color: #ece864;">{{show_min}}</span>
						<span v-if="show_min_c=='red'" style="color: #b41a3f;">{{show_min}}</span><br>


						参考范围：{{dat_line[map_name].d_max}}-{{dat_line[map_name].d_min}}°
					</div>
				</div>

				<div style="padding: 5px;display: flex;">
					<div v-if="dat[map_name+'_max']['img']!=''">
						<div style="font-size: 14px;text-align: center;">
							{{fs[map_name]}}最大伸展
						</div>
						<div style="max-width: 200px;max-height: 200px;">
							<img @click="show_img(dat[map_name+'_max']['img'])" style="max-width: 200px;max-height: 200px;" :src="dat[map_name+'_max']['img']" />
						</div>
					</div>
					<div v-if="dat[map_name+'_min']['img']!=''">
						<div style="font-size: 14px;text-align: center;">
							{{fs[map_name]}}最小收缩
						</div>
						<div style="max-width: 200px;max-height: 200px;">
							<img @click="show_img(dat[map_name+'_min']['img'])" style="max-width: 200px;max-height: 200px;" :src="dat[map_name+'_min']['img']" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<canvas id="cvs4" style="position: absolute;left: -9999px;top:-9999px"></canvas>
	</div>
</template>

<script>
	// import * as poseDetection from '@tensorflow-models/pose-detection';
	// import * as tf from '@tensorflow/tfjs-core';
	// import '@tensorflow/tfjs-backend-webgl';

	import * as poseDetection from '@tensorflow-models/pose-detection';
	import '@tensorflow/tfjs-core';
	import '@tensorflow/tfjs-backend-webgl';
	import '@mediapipe/pose';
	import * as tool from '../js/tool.js';
	export default {
		name: 'App',
		data() {
			return {
				shoulderData: [{
					angle: 0,
					timestamp: 0
				}],		
				crc_count:0,
				crc_time:0,
				crc_tmp:0,
				fps_count:0,
				fps:0,
				video: null,
				canvas1: null,
				canvas2: null,
				canvas3: null,
				canvas4: null,
				canvas5: null,
				canvas6: null,
				ctx1: null,
				ctx2: null,
				ctx3: null,
				ctx4: null,
				ctx5: null,
				ctx6: null,
				detector: null,
				chartDom: null,
				myChart: null,
				ybtdom: null,
				ybt: null,
				option_ybt: null,
				ybtdom2: null,
				ybt2: null,
				option_ybt2: null,
				avg_maxs: 0,
				avg_mins: 0,
				is_init: false, //首次开启运行
				show_max: 0,
				show_min: 0,
				show_max_c: "",
				show_min_c: "",
				avg_max: 0,
				avg_min: 0,
				can_fknee: false,
				dat_knee: [
					[0, 0],
					[0, 0]
				],
				allVideoDevices: [],
				cam_index: 0,
				call: "加载中",
				ready: false,
				jt: false,
				ddd: false,
				ck_list: [],
				dsc: "",
				left: "未知",
				id: 0,
				sta: 0,
				map_name: "knee",
				option: {
					series: [{
						data: [10, 22, 28, 23, 19],
						type: 'line',
						smooth: true
					}]
				},
				zt: false,
				vst: true,
				jd: ["knee", "hip", "shoulder", "elbow", "ankle", "wrist"],
				fs: {
					"knee": "膝关节",
					"hip": "髋关节",
					"shoulder": "肩关节",
					"elbow": "肘关节",
					"ankle": "踝关节",
					"wrist": "腕关节"
				},
				dats: {
					"knee": [],
					"hip": [],
					"shoulder": [],
					"elbow": [],
					"ankle": [],
					"wrist": []
				},
				def_dat: {},
				dat_line: {
					"knee": {
						u_max: 148,
						u_max_title: "考虑提高车座5mm并检查脚踏位置",
						u_min: 138,
						u_min_title: "降低车座5mm或检查曲柄长度是否过长",
						d_max: 73,
						d_min: 67 // 更正为与推荐范围一致
					},
					"hip": {
						u_max_title: "车座可能过于后仰",
						u_min_title: "车座可能过于前倾",
						u_max: 105,
						u_min: 90,
						d_max: 70,
						d_min: 55
					},
					"shoulder": {
						u_max_title: "车把可能过低，提高5mm-10mm以增加舒适度",
						u_min_title: "车把可能过高，降低5mm-10mm以获得更好的空气动力学位置",
						u_max: 90,
						u_min: 80,
						d_max: 90,
						d_min: 80
					},
					"elbow": {
						u_max_title: "车把可能过近或过高，调整5mm-10mm以增加伸展",
						u_min_title: "车把可能过远或过低，调整5mm-10mm以减少伸展",
						u_max: 170,
						u_min: 155,
						d_max: 170,
						d_min: 155
					},
					"ankle": {
						u_max_title: "考虑调整骑行姿势",
						u_min_title: "考虑调整骑行姿势",
						u_max: 130,
						u_min: 100,
						d_max: 130,
						d_min: 100
					},
					"wrist": {
						u_max_title: "调整车把倾斜和变速器位置以获得中性位置",
						u_min_title: "确保腕部不过度弯曲，避免压力和拉伤",
						u_max: 170,
						u_min: 150,
						d_max: 170,
						d_min: 150
					}
				},
				foot_index_max: 0,
				dat: {
					see_fx: {
						name: "视角方向",
						val: "未知",
						color: "green"
					},

					fknee_min: {
						name: "膝前量",
						val: "999",
						color: "green"
					},
					knee: {
						name: "膝关节当前角度",
						val: "0",
						color: "green"
					},
					knee_max: {
						name: "膝关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},

					knee_min: {
						name: "膝关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},
					hip: {
						name: "髋关节当前角度",
						val: "0",
						color: "green"
					},
					hip_max: {
						name: "髋关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					hip_min: {
						name: "髋关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},

					shoulder: {
						name: "肩关节当前角度",
						val: "0",
						color: "green",
						img: ""
					},
					shoulder_max: {
						name: "肩关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					shoulder_min: {
						name: "肩关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},

					elbow: {
						name: "肘关节当前角度",
						val: "0",
						color: "green",
						img: ""
					},
					elbow_max: {
						name: "肘关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					elbow_min: {
						name: "肘关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},

					ankle: {
						name: "踝关节当前角度",
						val: "0",
						color: "green",
						img: ""
					},
					ankle_max: {
						name: "踝关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					ankle_min: {
						name: "踝关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					},

					wrist: {
						name: "腕关节当前角度",
						val: "0",
						color: "green",
						img: ""
					},
					wrist_max: {
						name: "腕关节最大伸展角度",
						val: "0",
						color: "green",
						img: ""
					},
					wrist_min: {
						name: "腕关节最小收缩角度",
						val: "0",
						color: "green",
						img: ""
					}

				}
			};
		},
		created() {
			var that = this
			that.init_mode();
			that.$data.id = this.$route.query.id;
			that.init_dat();
			that.$data.def_dat = JSON.parse(JSON.stringify(that.$data.dat));
		},
		mounted() {
			var that = this
			that.video = document.getElementsByTagName('video')[0];
			that.canvas1 = document.getElementById("cvs1");
			that.canvas2 = document.getElementById("cvs2");
			that.canvas3 = document.getElementById("cvs3");
			that.canvas4 = document.getElementById("cvs5");
			that.canvas5 = document.getElementById("cvs4");
			that.canvas6 = document.getElementById("cvs6");
			that.ctx1 = that.canvas1.getContext("2d");
			that.ctx2 = that.canvas2.getContext("2d");
			that.ctx3 = that.canvas3.getContext("2d");
			that.ctx4 = that.canvas4.getContext("2d");
			that.ctx5 = that.canvas5.getContext("2d");
			that.ctx6 = that.canvas6.getContext("2d");
			that.chartDom = document.getElementById('qxt');
			that.myChart = echarts.init(that.chartDom);
			var ybt_dom = document.getElementById('ybt');
			that.ybt = echarts.init(ybt_dom);
			var ybt_dom2 = document.getElementById('ybt2');
			that.ybt2 = echarts.init(ybt_dom2);
			setInterval(function() {
				that.ref_fps()
			}, 1000);
			setInterval(function() {
				that.ref_map()
			}, 50);




		},
		methods: {
			...tool
		}
		// 可能的计算属性和方法...
	};
</script>

<style>
	.green {
		color: #00B83F;
	}

	.yellow {
		color: #ece864;
	}

	.red {
		color: #b41a3f;
	}
</style>